// the whatwg-fetch polyfill installs the fetch() function
// on the global object (window or self)
//
// Return that as the export for use in Webpack, Browserify etc.
require('whatwg-fetch');
module.exports = self.fetch.bind(self);



//////////////////
// WEBPACK FOOTER
// ./~/_isomorphic-fetch@2.2.1@isomorphic-fetch/fetch-npm-browserify.js
// module id = 720
// module chunks = 0